export default [
    {
        name: 'Contratos',
        url: '/fornecedor/contratos',
        icon: 'fa fa-file-text-o',
        regras: 'FORN-CONTRATOS-00',
        badge: {
            variant: 'primary',
            text: 'GESCON'
        }
    },
    {
        name: 'Pagamentos',
        url: '/fornecedor/contratos-pagamentos',
        icon: 'fa fa-file-text-o',
        regras: 'GESCON-FORN-PAG-00',
        badge: {
            variant: 'primary',
            text: 'GESCON'
        }
    }
]
